export const DESKTOP_TITLE_MAX_WIDTH = '422px';
export const DESKTOP_QUESTION_MAX_WIDTH = '422px';
